/**
 * Coerces an unknown backend field into a finite number, defaulting to 0.
 *
 * Numeric strings are parsed; non-finite numbers, non-numeric strings, and any
 * other type collapse to 0 so the analytics UI never crashes on a partial or
 * malformed response. Shared by every user-analytics fetcher.
 */
export function coerceUserAnalyticsNumber(value: unknown): number {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}
